import { ImageSelectorFromRepo } from "./EditImageConfig";
import Input from "../FormComponents/Input";

const EditFile = ({ editElementData, setEditElementData }) => {
  const handleChange = (name, value) => {
    setEditElementData((prevData) => ({
      ...prevData,
      image_placeholder: {
        ...prevData.image_placeholder,
        [name]: value
      }
    }));
  };

  const handleRootChange = (name, value) => {
    setEditElementData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const imageData = editElementData?.image_placeholder || {};

  return (
    <>
      <Input
        value={imageData.source || ""}
        onChange={(e) => handleChange("source", e.target.value)}
        name="source"
        label="Image Source"
        type="text"
      />
      <ImageSelectorFromRepo selected={imageData.repo_source} onChange={(obj) => handleChange("repo_source", obj.id)} />
      <Input
        type="checkbox"
        label="Allow Show Popup"
        name="open_on_popup"
        checked={editElementData?.open_on_popup || false}
        onChange={(e) => handleRootChange(e.target.name, e.target.checked)}
      />
    </>
  );
};

export default EditFile;
